export const ATTRIBUT_GRUPPE_IMPFSTATUS_ID = 112;

export const ATTRIBUT_GRUPPE_CHECK_MYBACK_IMPFSTATUS_ID = 20059;
export const ATTRIBUT_GRUPPE_CHECK_MYHEART_IMPFSTATUS_ID = 20083;
export const ATTRIBUT_GRUPPE_CHECK_MYMIND_IMPFSTATUS_ID = 20034;

export function isGruppeImpfungen(id: number): boolean {
  return (
    ATTRIBUT_GRUPPE_IMPFSTATUS_ID === id ||
    ATTRIBUT_GRUPPE_CHECK_MYBACK_IMPFSTATUS_ID === id ||
    ATTRIBUT_GRUPPE_CHECK_MYHEART_IMPFSTATUS_ID === id ||
    ATTRIBUT_GRUPPE_CHECK_MYMIND_IMPFSTATUS_ID === id
  );
}
